import { useState, useRef, useEffect, useCallback } from "react";

export const useRequestTimer = () => {
  const [requestTimerSeconds, setRequestTimerSeconds] = useState(0);
  const requestTimerIntervalRef = useRef(null);

  const stopRequestTimer = useCallback(() => {
    if (requestTimerIntervalRef.current) {
      clearInterval(requestTimerIntervalRef.current);
      requestTimerIntervalRef.current = null;
    }
  }, []);

  const startRequestTimer = useCallback(() => {
    stopRequestTimer();
    setRequestTimerSeconds(0);
    requestTimerIntervalRef.current = setInterval(() => {
      setRequestTimerSeconds((prev) => prev + 1);
    }, 1000);
  }, [stopRequestTimer]);

  useEffect(() => {
    return () => {
      stopRequestTimer();
    };
  }, [stopRequestTimer]);

  return {
    requestTimerSeconds,
    setRequestTimerSeconds,
    startRequestTimer,
    stopRequestTimer,
  };
};

